import React, { useEffect, useState } from "react";
import { getClientLogos } from "../api/clientService";
import { sleep } from "../utils/sleep";
import * as FaIcons from 'react-icons/fa';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const ClientLogos = () => {

  const [clientLogos, setClientLogos] = useState([]);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);
    
        useEffect(() => {
        const fetchClientLogos = async () => {
          try {
            // simulate network delay (3 sec)
            //await sleep(3000);
    
            const data = await getClientLogos(); // asynchronous call
            setClientLogos(data);
          } catch (err) {
            setError("Failed to load client details.");
          } finally {
            setLoading(false);
          }
        };
    
        fetchClientLogos();
        }, []);
      
      // Loading Overlay
      if (loading) {
        return (
          <div className="loading-overlay d-flex align-items-center justify-content-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
            <span className="ms-3 fw-semibold">Loading client details...</span>
          </div>
        );
      }
      
       // Error Message
      if (error) {
        return (
          <div className="error-container d-flex flex-column align-items-center justify-content-center py-5">
            <p className="text-danger fs-7">{error}</p>
            <button
              className="btn btn-outline-primary mt-3"
              onClick={() => window.location.reload()}
            >
              Retry
            </button>
          </div>
        );
    }

  return (
    <section className="py-5 bg-white text-center">
      <div className="container">
        <h2 className="fw-bold mb-4">
          Our <span className="text-primary-color">Clients</span>
        </h2>
        <p className="text-muted ps-3 mb-5">
          Trusted by businesses across industries to deliver excellence.
        </p>

        <Swiper
          modules={[Autoplay]}
          slidesPerView={2}
          spaceBetween={30}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          loop={true}
          breakpoints={{
            576: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            992: { slidesPerView: 5 },
          }}
        >
          {clientLogos.map((client, index) => (
            <SwiperSlide key={index}>
              <div className="client-logo">
                <img
                  src={require(`../assets/images/client/${client.logoName}`)}
                  alt={client.name}
                  className="img-fluid grayscale-hover"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ClientLogos;
